import * as React from 'react';
import { createPortal } from 'react-dom';

interface ReactPortalProps extends Partial<DefaultProps> {
    children: React.ReactNode;
}

interface DefaultProps {
    target: HTMLElement;
}

type ReactPortalPropsWithDefaults = ReactPortalProps & DefaultProps;

// Using a class component as the types for a stateless component don't support portals.
export class ReactPortal extends React.Component<ReactPortalProps> {
    static defaultProps: DefaultProps = {
        target: document.body,
    };

    render() {
        const { children, target } = this.props as ReactPortalPropsWithDefaults;
        return createPortal(children, target);
    }
}
